class GiftOptions extends HTMLElement {
  #saveTimer = null;
  #activeRequest = null;

  connectedCallback() {
    this.checkbox = this.querySelector('[data-gift-checkbox]');
    this.hiddenValue = this.querySelector('[data-gift-value]');
    this.message = this.querySelector('[data-gift-message]');
    this.messageWrapper = this.querySelector('[data-gift-message-wrapper]');
    this.status = this.querySelector('[data-gift-status]');

    if (!this.checkbox || !this.hiddenValue || !this.message) return;

    this.checkbox.addEventListener('change', this.handleCheckboxChange);
    this.message.addEventListener('input', this.handleMessageInput);
    this.message.addEventListener('blur', this.handleMessageBlur);

    this.updateVisibility();
  }

  disconnectedCallback() {
    this.checkbox?.removeEventListener('change', this.handleCheckboxChange);
    this.message?.removeEventListener('input', this.handleMessageInput);
    this.message?.removeEventListener('blur', this.handleMessageBlur);

    window.clearTimeout(this.#saveTimer);
    this.#activeRequest?.abort();
  }

  handleCheckboxChange = () => {
    this.hiddenValue.value = this.checkbox.checked ? 'Sí' : 'No';
    this.updateVisibility();

    if (!this.checkbox.checked) {
      this.message.value = '';
    }

    this.save();
  };

  handleMessageInput = () => {
    this.setStatus('Guardando…');

    window.clearTimeout(this.#saveTimer);
    this.#saveTimer = window.setTimeout(() => {
      this.save();
    }, 300);
  };

  handleMessageBlur = () => {
    window.clearTimeout(this.#saveTimer);
    this.save();
  };

  updateVisibility() {
    if (!this.messageWrapper) return;

    this.messageWrapper.hidden = !this.checkbox.checked;
  }

  async save() {
    window.clearTimeout(this.#saveTimer);
    this.#activeRequest?.abort();

    const abortController = new AbortController();
    this.#activeRequest = abortController;

    const isGift = this.checkbox.checked;
    const note = isGift ? this.message.value.trim() : '';

    this.hiddenValue.value = isGift ? 'Sí' : 'No';
    this.setStatus('Guardando…');

    try {
      const response = await fetch(Theme.routes.cart_update_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          note,
          attributes: {
            'Es un regalo': isGift ? 'Sí' : 'No',
          },
        }),
        signal: abortController.signal,
      });

      if (!response.ok) {
        throw new Error(`Cart update failed: ${response.status}`);
      }

      this.setStatus('Mensaje guardado');
    } catch (error) {
      if (error.name === 'AbortError') return;

      console.error('[Gift options]', error);
      this.setStatus('No se pudo guardar. Intenta nuevamente.', true);
    } finally {
      if (this.#activeRequest === abortController) {
        this.#activeRequest = null;
      }
    }
  }

  setStatus(message, isError = false) {
    if (!this.status) return;

    this.status.textContent = message;
    this.status.dataset.error = isError ? 'true' : 'false';
  }
}

if (!customElements.get('gift-options')) {
  customElements.define('gift-options', GiftOptions);
}